import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { AuditModal } from "../../../components/AuditTrail/AuditModal";
import { ExpandableContent } from "../../../components/CustomControls/ExpandableContent";
import { AdverseEvents } from "../../../components/MedicalRecords/AdverseEvents";
import { AuditTrail } from "../../Admin/AuditTrail";
import { useConditions } from "../Hooks/useConditions";
import { ModalAdverseEventHistory } from "../Modals/ModalAdverseEventHistory";
import { conditions } from "../../../variables/Enums";

export const ConditionsListContainer = ({ mrn, medicalRecordNumber, entryId, actual, chronic, title, expandedAll }) => {
    const { t } = useTranslation();
    const [data, query, totalSize, isLoading, handleTableChange] = useConditions(medicalRecordNumber, entryId, null ,actual, chronic);

    const [modal, setModal] = useState(null);
    const handleAuditTrail = (entityId) => {
        setModal(
            <AuditModal
                onClose={() => { setModal(null); }}
                title={t("auditTrail.audit")}
            >
                <AuditTrail entity="AdverseEvents" entityId={entityId} medicalRecordNumber={medicalRecordNumber} />
            </AuditModal>
        )
    }
    const handleHistory = (_itemId, _mrn, item) => {
        
        setModal(<ModalAdverseEventHistory
            onClose={() => { setModal(null); }}
            title={t("medicalRecords.history.history")}
            medicalRecordNumber={medicalRecordNumber || mrn}
            conceptId={item.name?.conceptId}
            condition={conditions.diagnosis}
        />)
    }

    const _title = title ?? t("medicalRecords.condition.title");
    if (entryId && totalSize === 0)
        return null;
        
    return (
        <ExpandableContent title={_title} content="adverseEvents" expandedAll={expandedAll}>
            {modal}
            <AdverseEvents
                withCard={false}
                data={data}
                query={query}
                totalSize={totalSize}
                isLoading={isLoading}
                onTableChange={handleTableChange}
                onAuditTrail={handleAuditTrail}
                onHistory={handleHistory}
            />
        </ExpandableContent>
    );
}